import React from 'react'
import { Image } from '@/components/elements/Image'

export interface HeroImageProps {
  picture: string
  backgroundBlendColor?: string
}

export const HeroImage: React.FC<HeroImageProps> = ({
  picture,
  backgroundBlendColor = 'bg-orange',
}) => (
  <div className="relative h-56 lg:h-96">
    <Image
      className="absolute z-10 inset-0 pointer-events-none grayscale filter"
      src={picture}
      layout="fill"
      objectPosition="center"
      objectFit="cover"
      priority
      quality={55}
      alt=""
    />
    <div
      className={`absolute z-20 inset-0 mix-blend-multiply ${backgroundBlendColor}`}
    />
  </div>
)
